import * as React from "react";
import {LoadableProps} from "../common/props/LoadableProps";
import {none, option, Option} from "ts-option";
import Attachment from "../../model/attachment/Attachment";
import "./primaryAndOtherFilesDropDown.scss"
import SingleFileDropDown from "./SingleFileDropDown";
import Col from "../layout/Col";
import Row from "../layout/Row";

interface ComponentProps {
	/**
	 * On add or update file
	 * @param file
	 */
	onAddOrUpdateFile: (file: (File | Attachment)[]) => void;
	/**
	 * Attachments
	 */
	attachments: Option<Attachment[]>;
}

interface State {
	errors?: Option<string[]>;
	primaryFile: File
	secondaryFile: File
	tertiaryFile: File
	removedFiles: boolean[]
}

type Props = ComponentProps & LoadableProps;

export default class PrimaryAndOtherFilesDropDown extends React.Component<Props, State> {

	constructor(props: Props) {
		super(props);

		this.state = {
			primaryFile: null,
			secondaryFile: null,
			tertiaryFile: null,
			errors: none,
			removedFiles: [false, false, false]
		};
	}

	render() {
		return (
			<div className={'c-primary-and-other-files-selector'}>
				<Row>
					<Col xl={4} md={4}>
						<div className={"c-primary-and-other-files-selector_label"}>Primary file</div>
						<div className={"c-primary-and-other-files-selector_drop_zone"}>
							<SingleFileDropDown attachment={this.props.attachments.flatMap(a => option(a[0]))}
												onDropFile={(f) => this.onAddFile(f, 0)}
												onRemove={() => this.onRemoveFile(0)}/>
						</div>
					</Col>
					<Col xl={4} md={4}>
						<div className={"c-primary-and-other-files-selector_label"}>Secondary file</div>
						<div className={"c-primary-and-other-files-selector_drop_zone"}>
							<SingleFileDropDown attachment={this.props.attachments.flatMap(a => option(a[1]))}
												onDropFile={(f) => this.onAddFile(f, 1)}
												onRemove={() => this.onRemoveFile(1)}/>
						</div>
					</Col>
					<Col xl={4} md={4}>
						<div className={"c-primary-and-other-files-selector_label"}>Tertiary file</div>
						<div className={"c-primary-and-other-files-selector_drop_zone"}>
							<SingleFileDropDown attachment={this.props.attachments.flatMap(a => option(a[2]))}
												onDropFile={(f) => this.onAddFile(f, 2)}
												onRemove={() => this.onRemoveFile(2)}/>
						</div>
					</Col>
				</Row>
			</div>
		)
	}

	onAddFile = (file: File, index: number) => {
		const removedFiles: boolean[] = [...this.state.removedFiles];
		removedFiles[index] = false;
		switch (index) {
			case 0:
				this.setState({primaryFile: file, removedFiles}, this.notifyAboutFileChanges);
				break;
			case 1:
				this.setState({secondaryFile: file, removedFiles}, this.notifyAboutFileChanges);
				break;
			case 2:
				this.setState({tertiaryFile: file, removedFiles}, this.notifyAboutFileChanges);
				break;
		}
	}

	onRemoveFile = (index: number) => {
		const removedFiles: boolean[] = [...this.state.removedFiles];
		removedFiles[index] = true;
		switch (index) {
			case 0:
				this.setState({primaryFile: null, removedFiles}, this.notifyAboutFileChanges);
				break;
			case 1:
				this.setState({secondaryFile: null, removedFiles}, this.notifyAboutFileChanges);
				break;
			case 2:
				this.setState({tertiaryFile: null, removedFiles}, this.notifyAboutFileChanges);
				break;
		}
	}

	notifyAboutFileChanges = () => {
		const files: (File | Attachment)[] = [];
		if (this.state.primaryFile || (this.props.attachments.getOrElse([]).length > 0 && !this.state.removedFiles[0])) {
			if (this.state.primaryFile)
				files.push(this.state.primaryFile);
			else
				this.props.attachments.map(a => files.push(a[0]));
		}
		if (this.state.secondaryFile || (this.props.attachments.getOrElse([]).length > 1 && !this.state.removedFiles[1])) {
			if (this.state.secondaryFile)
				files.push(this.state.secondaryFile);
			else
				this.props.attachments.map(a => files.push(a[1]));
		}
		if (this.state.tertiaryFile || (this.props.attachments.getOrElse([]).length > 2 && !this.state.removedFiles[2])) {
			if (this.state.tertiaryFile)
				files.push(this.state.tertiaryFile);
			else
				this.props.attachments.map(a => files.push(a[2]));
		}
		this.props.onAddOrUpdateFile(files);
	}

}